import _common from '@js/common';
import _config from '@js/config';
import qt_util from '@libs/qt/util';
import qt_storage from '@libs/qt/storage';

export default {
    data() {
        return {
            qyVipData: {
                chargeCode: '',                         //  业务码
                chargeName: '',                         //  业务名称
                expireAt: '',                           //  过期时间戳
                expireAtLabel: '',                      //  过期时间文案
                isExpire: false,                        //  是否已过期
                isShowExpireTips: false,                //  是否显示即将过期提示
            },
        }
    },
    methods: {
        // 获取vip信息
        queryVipData () {
            return new Promise((resolve, reject) => {
                // let {qyVipData} = this;
                let qyVipData = {
                    chargeCode: '',                         //  业务码
                    chargeName: '',                         //  业务名称
                    expireAt: '',                           //  过期时间戳
                    expireAtLabel: '',                      //  过期时间文案
                    isExpire: false,                        //  是否已过期
                    isShowExpireTips: false,                //  是否显示即将过期提示
                }
                this._postSign({
                    url: this._config.SERVICE + '/extend/pro/schadm/order/vip/info',
                    params: {},
                    success: (res) => {
                        if ('001' == res.resultCode) {
                            const {qyVips} = res.data;
                            const todayTime = new Date().getTime();
                            qyVips.forEach(item => {
                                const {chargeCode, chargeName, expireAt} = item;
                                if (expireAt > qyVipData.expireAt) {
                                    qyVipData.chargeCode = chargeCode;
                                    qyVipData.expireAt = expireAt;
                                }
                            });
                            if (qyVipData.chargeCode) {
                                if (qyVipData.chargeCode == 'tea_vip_120') {
                                    qyVipData.chargeName = '校园版';
                                } else {
                                    qyVipData.chargeName = '校园高级版';
                                }
                                qyVipData.expireAtLabel = qt_util.formatDate(qyVipData.expireAt, 'yyyy年MM月dd日');
                                // 过期日期7天前
                                const lastTime = qyVipData.expireAt - 7 * 24 * 60 * 60000;
                                if (todayTime > qyVipData.expireAt) {
                                    qyVipData.isExpire = true;
                                } else if (todayTime > lastTime) {
                                    qyVipData.isShowExpireTips = true;
                                }
                            }
                            qt_storage.sessionSet('qyVip_data',JSON.stringify(qyVipData));
                            resolve(qyVipData);
                        } else {
                            _common.tips(res.resultMsg);
                            resolve(qyVipData);
                        }
                    },
                    fail: () => {
                        _common.tips('/extend/pro/schadm/order/vip/info服务异常，请稍后重试');
                        resolve(qyVipData);
                    }
                });
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/mixins/vip.js